export default __webpack_public_path__ + "static/media/CarImages.K2700Small.86023d25.jpg";